import { useQuery } from "@tanstack/react-query";
import { getSelfCompaniesAction } from "../actions/companies-actions";


export const useCompanies = (token?: string | null) => {
  return useQuery({
    queryKey: ["companies-self", token],
    retry: false,
    queryFn: () => getSelfCompaniesAction(),
    enabled: !!token,
  });
};